import RuleModal from '@businessComponents/games/rule';
import DigitRule from '@/common-pages/pick-digit/digit-rule';
import React, {useEffect, useState} from 'react';
import {RulesIcon} from '@/common-pages/invitation/svg.variables';
import {useTranslation} from 'react-i18next';
import theme from '@style';

type GameName =
  | 'NEW_USER_RANK_ACTIVITY'
  | 'FISSION_RANK_ACTIVITY'
  | 'DAILY_BETTING_CHAMPIONSHIP'
  | 'OLD_USER_RANK_ACTIVITY'
  | 'PK_RANK_ACTIVITY';
export default function Rule(props: {
  gameName: GameName;
  icon?: React.ReactNode;
}) {
  const {gameName, icon} = props;
  const [visible, setVisible] = useState(false);
  const {t} = useTranslation();

  useEffect(() => {
    if (gameName !== 'PK_RANK_ACTIVITY') {
      return;
    }
    const storageKey = 'PK_RANK_ACTIVITY_RULE_SHOWN';
    if (!localStorage.getItem(storageKey)) {
      setVisible(true);
      localStorage.setItem(storageKey, 'true');
    }
  }, [gameName]);
  const toRule = () => {
    setVisible(true);
  };
  return (
    <>
      <div className="flex gap-1 items-center" onClick={toRule}>
        {icon ? (
          icon
        ) : (
          <RulesIcon className="size-6" fill={theme.fontColor.accent} />
        )}
        {icon ? (
          <span className="text-[#F0DE82] font-medium">
            {t('invitation.home.rules')}
          </span>
        ) : (
          <span className="text-t3 font-medium">
            {t('invitation.home.rules')}
          </span>
        )}
      </div>
      <RuleModal
        visible={visible}
        onClose={() => setVisible(false)}
        title="Rule"
        scrollEnabled={false}>
        <DigitRule gameName={gameName} />
      </RuleModal>
    </>
  );
}
